import React, { Component } from 'react';
import PropTypes from 'prop-types';
import config from '../config';

class EdgePolyLine extends Component {
  shouldComponentUpdate(nextProps) {
    const { isHighlighted: nextisHighlighted, polylinePoints: nextpolylinePoints } = nextProps;
    const { isHighlighted, polylinePoints } = this.props;
    if (nextisHighlighted !== isHighlighted) {
      return true;
    }

    if (nextpolylinePoints.length !== polylinePoints.length) {
      return true;
    }

    for (let i = 0; i < nextpolylinePoints.length; ++i) {
      if (nextpolylinePoints[i].x !== polylinePoints[i].x || nextpolylinePoints[i].y !== polylinePoints[i].y) {
        return true;
      }
    }

    return false;
  }

  render() {
    const { isHighlighted, polylinePoints } = this.props;
    const polylinePointsCoordinates = [];

    if (polylinePoints.length === 0) {
      return (
        <g />
      );
    }

    for (const point of polylinePoints) {
      polylinePointsCoordinates.push(point.x, point.y);
    }
    const stroke = isHighlighted ? '#4060b4' : 'rgb(61, 129, 164)';
    const strokeWidth = isHighlighted ? config.sizes.highlightStrokeWidth : 1;

    return (
      <g>
        <polyline points={polylinePointsCoordinates.join(',')} style={{ fill: 'none', stroke, strokeWidth }} />
      </g>
    );
  }
}

EdgePolyLine.propTypes = {
  isHighlighted: PropTypes.bool.isRequired,
  polylinePoints: PropTypes.array.isRequired,
};

export default EdgePolyLine;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/graph/components/EdgePolyLine.jsx